import Layout from '../../components/Layout';
import { Helmet } from 'react-helmet-async';
import PortfolioItem from '../../components/portfolio/PortfolioItem';
import { Box, Typography, Link as MuiLink } from '@mui/material';

function Portfolio() {
    const dateStarted = new Date('2015-08-10');
    const dateNow = new Date();
    const yearsExperience = getYearsOfExperience(dateStarted, dateNow);

    return (
        <Layout>
            <Helmet>
                <title>Portfolio — Rojan Thomas</title>
                <meta name="description" content="Apps and projects by Rojan Thomas. Personal projects and professional work at Tesco, comparethemarket, Costa, and Argos." />
            </Helmet>
            {/* Page header */}
            <Box
                sx={{
                    marginBottom: 3,
                    paddingBottom: 2.5,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <Typography
                    variant="h2"
                    sx={{
                        marginBottom: 1.5,
                        fontSize: { xs: '1.1rem', sm: '1.25rem' },
                        fontWeight: 500,
                        color: 'text.secondary',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                    }}
                >
                    Portfolio
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.secondary',
                        lineHeight: 1.5,
                        fontSize: '0.9rem',
                    }}
                >
                    I have {yearsExperience} years of professional experience working on various apps, and I also build my own.
                </Typography>
            </Box>

            {/* Personal Projects */}
            <Typography
                variant="h3"
                sx={{
                    marginBottom: 1.5,
                    fontSize: { xs: '0.95rem', sm: '1.05rem' },
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                }}
            >
                Personal Projects
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    marginBottom: 4,
                }}
            >
                <MuiLink
                    href="/caloriex"
                    sx={{
                        textDecoration: 'none',
                        color: 'inherit',
                    }}
                >
                    <PortfolioItem
                        image="./caloriex/images/app-icon.png"
                        title="CalorieX"
                        desc="AI-powered calorie and nutrition tracking app."
                    />
                </MuiLink>
            </Box>

            {/* Professional Work */}
            <Typography
                variant="h3"
                sx={{
                    marginBottom: 1.5,
                    fontSize: { xs: '0.95rem', sm: '1.05rem' },
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                }}
            >
                Professional Work
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <MuiLink
                    href="https://play.google.com/store/apps/details?id=com.tesco.grocery.view"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        textDecoration: 'none',
                        color: 'inherit',
                    }}
                >
                    <PortfolioItem
                        image="./portfolio_image_tesco.webp"
                        title="Tesco Grocery & Clubcard"
                        desc="Tesco clubcard & shopping app."
                    />
                </MuiLink>

                <MuiLink
                    href="https://play.google.com/store/apps/details?id=com.ctm.cinema"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        textDecoration: 'none',
                        color: 'inherit',
                    }}
                >
                    <PortfolioItem
                        image="./portfolio_image_meerkat.webp"
                        title="comparethemarket.com"
                        desc="Compare prices & use your Meerkat Rewards."
                    />
                </MuiLink>

                <MuiLink
                    href="https://play.google.com/store/apps/details?id=uk.co.club.costa.costa"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        textDecoration: 'none',
                        color: 'inherit',
                    }}
                >
                    <PortfolioItem
                        image="./portfolio_image_costa.webp"
                        title="Costa Coffee Club"
                        desc="Costa Coffee Club loyalty app to collect beans and order your favourite drink."
                    />
                </MuiLink>

                <MuiLink
                    href="https://play.google.com/store/apps/details?id=com.homeretailgroup.argos.android"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        textDecoration: 'none',
                        color: 'inherit',
                    }}
                >
                    <PortfolioItem
                        image="./portfolio_image_argos.webp"
                        title="Sainsbury's Argos"
                        desc="Browse thousands of products to buy with click & collect or delivery."
                    />
                </MuiLink>
            </Box>
        </Layout>
    );
}

function getYearsOfExperience(dateFrom, dateTo) {
    return Math.round(
        (dateTo.getMonth() - dateFrom.getMonth() + (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))) / 12
    );
}

export default Portfolio;
